import React, { useState, useCallback } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import useMediaQuery from "@mui/material/useMediaQuery";

import AssetQuantityField from "../../../../../views/inventory/requests/AssetQuantityField";

export default function TotalReceivingUnitsForm({
  value,
  quantityLabel,
  addLabel,
  onSave,
  typeKey = "shipment_type",
  quantityKey = "received",
  typeOptions,
}) {
  const initReceivingUnits = { [typeKey]: "", [quantityKey]: 1 };
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const arrayTotalPieces = Array.isArray(value) ? value : [];
  const initialValues = arrayTotalPieces.length === 0 ? [initReceivingUnits] : arrayTotalPieces;
  const [totalPieces, setTotalPieces] = useState(initialValues);

  const handleTypeChange = useCallback(
    (index, newValue) => {
      setTotalPieces(
        totalPieces.map((item, i) => (i === index ? { ...item, [typeKey]: newValue || "" } : item))
      );
    },
    [totalPieces, typeKey]
  );

  const handleQuantityChange = useCallback(
    (index, quantity) => {
      setTotalPieces(
        totalPieces.map((item, i) => (i === index ? { ...item, [quantityKey]: quantity } : item))
      );
    },
    [totalPieces, quantityKey]
  );

  const handleDeleteItem = useCallback(
    index => {
      setTotalPieces(totalPieces.filter((_, i) => i !== index));
    },
    [totalPieces]
  );

  const handleAddItem = useCallback(() => {
    setTotalPieces([...totalPieces, initReceivingUnits]);
  }, [totalPieces, initReceivingUnits]);

  const handleSubmit = useCallback(() => {
    onSave(totalPieces);
  }, [onSave, totalPieces]);

  return (
    <>
      <Grid container spacing={isMobile ? 1 : 2}>
        {totalPieces.map((location, index) => {
          return (
            <React.Fragment key={index}>
              <Grid size={{ xs: 6, sm: 5 }}>
                <Autocomplete
                  size="medium"
                  fullWidth
                  options={typeOptions}
                  value={totalPieces[index][typeKey] || null}
                  onChange={(event, newValue) => handleTypeChange(index, newValue)}
                  renderInput={params => <TextField {...params} label="Unit Type" />}
                />
              </Grid>
              <Grid size={{ xs: 6, sm: 7 }}>
                <Box display="flex" justifyContent="">
                  <Box ml={-1} display="flex" alignItems="center">
                    <AssetQuantityField
                      displayButtons={!isMobile}
                      size="large"
                      quantity={totalPieces[index][quantityKey]}
                      onChange={quantity => handleQuantityChange(index, quantity)}
                      quantityProps={{
                        label: quantityLabel,
                        style: { minWidth: 90 },
                        InputLabelProps: {
                          shrink: true,
                        },
                      }}
                    />
                  </Box>
                  <IconButton sx={{ ml: 1 }} onClick={() => handleDeleteItem(index)}>
                    <DeleteIcon color="action" />
                  </IconButton>
                </Box>
              </Grid>
            </React.Fragment>
          );
        })}
      </Grid>
      <Box mt={2} display="flex">
        <Button variant="outlined" color="primary" onClick={handleAddItem} startIcon={<AddIcon />}>
          {addLabel}
        </Button>
      </Box>
      <Box mt={4} />
      <Box display="flex" justifyContent="flex-end">
        <Button
          color="primary"
          variant="contained"
          disabled={!totalPieces.every(item => item[quantityKey] && item[typeKey])}
          sx={{ textTransform: "none" }}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </Box>
    </>
  );
}
